import React, {useEffect, useState} from "react";
import {Filter} from "../Filter";

export default function FeedbackStatusFilter({statusData, filteredData, expanded, onExpandClick, onStatusUpdate, name}) {
    const [statusList, setStatusList] = useState([]);
    const handleChange = (event) => {
        const updatedList = statusList.map(list => {
            if (list.name === event.target.name) {
                list.checked = event.target.checked
            }
            return list
        })
        onStatusUpdate(updatedList)
        setStatusList(updatedList)
    };

    useEffect(() => {
        const list = statusData.map(item => {
            return filteredData.includes(item.description) ? {
                name: item.description,
                label: item.description,
                checked: true
            } : {name: item.description, label: item.description, checked: false}
        })

        setStatusList(list)
    }, [statusData, filteredData]);

    return (
        <Filter expanded={expanded} onChange={onExpandClick} statusList={statusList}
                onFilterUpdate={handleChange} name={name}/>
    );
}
